import React from 'react';
import {motion} from 'framer-motion';
import {FaIndustry, FaUsers, FaProjectDiagram, FaGlobeAfrica} from 'react-icons/fa';
import './Stats.css';
import {useTranslation} from "react-i18next";
import {Col } from "react-bootstrap";

export interface Stat {
    icon: React.ReactNode;
    number: string;
    title: string;
}


interface StatsProps {
    className?: string;
}

const Stats: React.FC<StatsProps> = ({className}) => {
    const {t} = useTranslation();
// Stats data
    var stats: Stat[] = [
        {
            icon: <FaIndustry/>,
            number: `${new Date().getFullYear() - 2021}+`,
            title: t('about.stats.experienceYears', 'Années d\'Expérience')
        },
        {
            icon: <FaUsers/>,
            number: '35+',
            title: t('about.stats.clients', 'Clients Satisfaits')
        },
        {
            icon: <FaProjectDiagram/>,
            number: '25+',
            title: t('about.stats.projects', 'Projets Réalisés')
        },
        {
            icon: <FaGlobeAfrica/>,
            number: '+95%',
            title: t('about.stats.satisfaction', 'Taux de satisfaction')
        }
    ];


    return (
        <section className={`stats-section-h ${className || ''}`}>
            <div className="container">
                <Col lg={10} className="text-center">
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{once: true}}
                    >
                        <h2 className="section-title text-white"> {t('about.stats.title', 'Nos Réalisations')}</h2>
                        <p className="lead mb-5">{t('about.stats.subtitle', 'Quelques chiffres clés sur notre impact')}</p>
                    </motion.div>
                </Col>

                <div className="stats-grid">
                    {stats.map((stat, index) => (
                        <motion.div
                            key={index}
                            className="stat-item"
                            initial={{opacity: 0, y: 30}}
                            whileInView={{opacity: 1, y: 0}}
                            transition={{duration: 0.6, delay: index * 0.1}}
                            viewport={{once: true}}
                        >
                            <div className="stat-icon">{stat.icon}</div>
                            <h3 className="stat-number-h">{stat.number}</h3>
                            <p className="stat-title">{stat.title}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Stats;
